export enum FeatureFlag {
  VasRbcGicExtendedCountries = 'vas_rbc_gic_extended_countries',
  VasLoanFollowupForm = 'vas_loan_followup_form',
}
